import { routes } from "../../common/routes/routes";
import { Permission } from "../../core/types/permission.enum";
import { WhenPermission } from "../../core/WhenPermission";
import { NavBarBase } from "../../layout/nav-bar/components/NavBarBase";
import { NavBarNavItem } from "../../layout/nav-bar/components/NavbarNavItem";

export const LegacyNavBar = () => {
  return (
    <NavBarBase
      beforeNavButtons={
        <>
          <NavBarNavItem
            to={routes.appointmentBooking.locationEdit.path}
            text={routes.appointmentBooking.locationEdit.text}
            iconName="Settings"
          />
          <WhenPermission permission={Permission.ProsBpmWebAllowed}>
            <NavBarNavItem
              text="Jump to ..."
              items={[
                routes.bpMobileDashboard.basePath,
                routes.bpMobileBooking.appointments,
                routes.bpMobileAddressBook.patients,
                routes.bpMobileTodo.userInbox
              ]}
            />
          </WhenPermission>
        </>
      }
    />
  );
};
